import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-slate-900 pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-90">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-slate-900 opacity-80" data-id="element-91"></div>
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-amber-500/5 blur-[120px]" data-id="element-92"></div>

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-start text-left z-10" data-id="element-94">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-amber-500 text-sm font-bold uppercase tracking-wider mb-6" data-id="element-95">
            <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" data-id="element-96"></span>
            Método Comprobado
          </div>

          <h1 className="text-5xl sm:text-6xl md:text-7xl font-oswald font-bold text-white leading-[1.1] mb-6 uppercase" data-id="element-97">
            CDL CLASS A: <br data-id="element-98" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-99">
              EL ATAJO
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-slate-300 font-medium mb-10 leading-relaxed max-w-2xl" data-id="element-100">
            Aprueba el examen teórico del DMV en 7 días y asegura tu primer
            cheque de{' '}
            <span className="text-emerald-400 font-bold" data-id="element-101">$1,500 semanales</span>{' '}
            sin ser bilingüe.
          </p>

          <CTAButton data-id="element-102" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative z-10 flex justify-center lg:justify-end" data-id="element-103">
          <div className="relative w-full max-w-md" data-id="element-104">
            <div className="absolute inset-0 bg-amber-500/20 rounded-2xl blur-2xl transform rotate-3 scale-105" data-id="element-105"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cStpERSMD25kscU9eiRgD7/IMAGE_PAGE.png" alt="CDL Class A: El Atajo Digital Guide" className="relative rounded-2xl shadow-2xl border border-slate-700/50 object-cover w-full h-auto transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-106" />
          </div>
        </motion.div>
      </div>
    </section>;
}